import { Translate } from '@chipinside/translate'
import { toast } from 'sonner'

type ImageValidationProps = {
  file?: File
  accept?: string
}

// Validação para drag também
export const imageValidation = ({ accept, file }: ImageValidationProps) => {
  if (!file || !accept) return true

  const [type, extension] = file.type?.split('/') ?? []

  if (type !== 'image') {
    toast.error(Translate({ messageKey: 'invalid_image_file' }))
    return false
  }

  const extensions = accept.split(',').map(accepted => accepted.trim().substring(1))

  if (!extensions.includes(extension)) {
    const params = { formats: extensions.join(', ') }

    toast.error(Translate({ messageKey: 'unsupported_image_format', params }))
    return false
  }

  return true
}
